/**
 * The project nav in words: where each of a project's three pages is, and how
 * the share's state is said. Kept apart from the component so the tests at the
 * root can run it without React.
 */

export type ProjectPage = "edit" | "export" | "views";

/** Edit is the editor for a product video and the studio for a launch film; the other two are the same for both. */
export function projectNavLinks(
  projectId: string,
  kind: "demo" | "launch",
): { page: ProjectPage; label: string; href: string }[] {
  const base = `/projects/${projectId}`;
  return [
    { page: "edit", label: "Edit", href: kind === "launch" ? base : `${base}/editor` },
    { page: "export", label: "Export & share", href: `${base}/render` },
    { page: "views", label: "Views", href: `${base}/views` },
  ];
}

/** Live in green, Draft in orange; nothing while it is not known. */
export function shareStatus(published: boolean | null): { label: "Live" | "Draft"; className: string } | null {
  if (published === null) return null;
  return published
    ? { label: "Live", className: "bg-[#E7F6EC] text-[#1C6B34]" }
    : { label: "Draft", className: "bg-[#FFE8D6] text-[#9A3A00]" };
}
